/* ============================================================
   THE LAST RIDE SALE – Countdown, Badge-Position, Aktionsende
   window.LR_END wird in layout/theme.liquid gesetzt (ms).
   Desktop (ab 990px): Badge sitzt fest im Header rechts neben den Icons.
   Mobil: Badge schwebt oben rechts unter dem Header.
   ============================================================ */
(function () {
  var END = window.LR_END || 0;
  if (!END) return;

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function expire() {
    document.querySelectorAll('[data-last-ride]').forEach(function (el) { el.remove(); });
    if (document.querySelector('[data-lr-page]') && !(window.Shopify && window.Shopify.designMode)) {
      window.location.replace((window.routes && window.routes.root_url ? window.routes.root_url.replace(/\/$/, '') : '') + '/collections/angebote');
    }
  }

  function tick() {
    var t = Math.max(0, Math.floor((END - Date.now()) / 1000));
    if (t <= 0) { expire(); return false; }
    var d = Math.floor(t / 86400);
    var h = Math.floor((t % 86400) / 3600);
    var m = Math.floor((t % 3600) / 60);
    var s = t % 60;
    document.querySelectorAll('[data-lr-countdown]').forEach(function (box) {
      var padDays = box.hasAttribute('data-lr-pad-days');
      box.querySelectorAll('[data-lr-unit]').forEach(function (u) {
        var k = u.getAttribute('data-lr-unit');
        u.textContent = k === 'd' ? (padDays ? pad(d) : d) : k === 'h' ? pad(h) : k === 'm' ? pad(m) : pad(s);
      });
    });
    return true;
  }

  var badge = null;
  var homeParent = null;
  var desktop = window.matchMedia('(min-width: 990px)');

  function mountBadge() {
    if (!badge) return;
    var slot = document.querySelector('#header .head-slot-end');
    if (desktop.matches && slot) {
      if (badge.parentElement !== slot) {
        slot.appendChild(badge);
        slot.classList.add('lr-has-badge');
      }
      badge.classList.add('lr-badge--inline');
      badge.style.top = '';
    } else {
      if (slot) slot.classList.remove('lr-has-badge');
      if (homeParent && badge.parentElement !== homeParent) homeParent.appendChild(badge);
      badge.classList.remove('lr-badge--inline');
    }
    placeBadge();
  }

  function placeBadge() {
    if (!badge || badge.classList.contains('lr-badge--inline')) return;
    var top = 12;
    var header = document.getElementById('header');
    if (header) {
      var r = header.getBoundingClientRect();
      if (r.bottom > 0) top = Math.round(r.bottom) + 12;
    }
    badge.style.top = top + 'px';
    var covered = document.querySelector('.mobile-menu[aria-hidden="false"], .drawer.open, .drawer[aria-hidden="false"], .drawer.active, body.overflow-hidden');
    badge.classList.toggle('is-covered', !!covered);
  }

  function start() {
    if (tick() === false) return;
    var iv = setInterval(function () { if (tick() === false) clearInterval(iv); }, 1000);

    badge = document.querySelector('.lr-badge');
    if (badge) {
      homeParent = badge.parentElement;
      mountBadge();
      badge.classList.add('is-ready');
      var raf = 0;
      var schedule = function () {
        if (raf) return;
        raf = requestAnimationFrame(function () { raf = 0; placeBadge(); });
      };
      window.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', schedule);
      if (desktop.addEventListener) desktop.addEventListener('change', mountBadge);
      else if (desktop.addListener) desktop.addListener(mountBadge);
      document.addEventListener('click', function () { setTimeout(placeBadge, 350); });
      setInterval(placeBadge, 1000);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
